import React from "react";
import { useNavigate } from "react-router-dom";
import { FaSignOutAlt, FaUser } from "react-icons/fa";
import styles from "./Topbar.module.scss";
import { useAuth } from "../context/AuthContext";

function Topbar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    if (window.confirm("Are you sure you want to logout?")) {
      logout();
      navigate("/login");
    }
  };

  return (
    <div className={styles.topbar}>
      <div className={styles.titleSection}>
        <h2 className={styles.title}>PALAIS ROYAL</h2>
        <p className={styles.subtitle}>Administration</p>
      </div>
      <div className={styles.userSection}>
        {user && (
          <div className={styles.userInfo}>
            <div className={styles.userAvatar}>
              {(user.username || "A").charAt(0).toUpperCase()}
            </div>
            <span className={styles.username}>{user.username || "Administrator"}</span>
          </div>
        )}
          <button
            className={styles.logoutBtn}
            onClick={handleLogout}
            title="Déconnexion"
          >
            <span>Déconnexion</span>
          </button>
      </div>
    </div>
  );
}

export default Topbar;
